/*
Contents of this file was produced with a help of a code generation tool and subsequently reviewed and edited by a human.

While some of the code was created by an AI assisted service, manual adjustments have been made to ensure correctness, readability, functionality and compliance to Avalara's coding standards and guidelines.
Any future modifications should be approached with caution to avoid overwriting the manual changes.

This source code is owned by Avalara Inc. Unauthorized copying of this file, via any medium, is strictly prohibited. Proprietary and confidential.

For more information, refer to the documentation or contact the development team.
*/

// this file is for the aui-company-switcher inside the aui-sidenav.
// the popper is attached outside the aui-company-switcher, but inside the aui-sidenav.
// therefore, the root of the CSS needs to be aui-sidenav, not aui-company-switcher.
aui-sidenav {
  .company-switcher {
    align-items: center;
    display: flex;
    justify-content: center;
    padding-block-start: var(--padding-sm);
    position: relative;

    &.expanded {
      justify-content: flex-start;
      padding-block-start: 0;
      padding-inline-start: var(--padding-sm);
    }

    button.ghost[disabled] {
      color: var(--color-gray-darkest);
      cursor: default;
    }

    .company-info {
      inline-size: calc(100% - 8px);
      padding: 0;
      text-align: start;

      &.pad-all-md {
        padding: var(--padding-md);
      }

      &:focus:not(:focus-visible) {
        box-shadow: none;
        outline: none;
      }
    }
  }

  .company-info {
    block-size: auto;
  }

  .company-icon {
    align-items: center;
    background-color: var(--color-blue-dark);
    block-size: 36px;
    border-radius: 4px;
    color: var(--color-white);
    display: flex;
    font-size: var(--font-size-lg);
    font-weight: normal;
    inline-size: 36px;
    justify-content: center;
    line-height: var(--line-height-xl);
    min-inline-size: 36px;

    &.clickable {
      &:hover {
        background-color: var(--color-blue-darker);
      }
    }
  }

  .company-name-wrapper {
    display: flex;
    flex-direction: column;
    inline-size: calc(100% - 36px);
    max-inline-size: calc(100% - 36px);
    min-inline-size: 0; // Important for flex child to respect container width
    padding-inline-start: var(--padding-md);
  }

  .company-name {
    font-weight: 600; /* semibold */
    inline-size: 100%;
    line-height: var(--line-height-sm);
    overflow-wrap: break-word;
    white-space: normal;
    word-break: normal;
  }

  .company-code {
    color: var(--color-gray-dark);
    font-size: var(--font-size-xs);
    font-weight: 400;
    line-height: var(--line-height-sm);
  }

  .company-name-list {
    display: block;
    font-weight: normal;
    inline-size: 100%;
    overflow-wrap: break-word;
    text-overflow: clip;
    white-space: normal;
    word-break: normal;
  }

  .company-link {
    color: var(--color-blue-dark);
    cursor: pointer;
    font-size: var(--font-size-xs);
    font-weight: normal;
    line-height: var(--line-height-sm);
    text-decoration: underline;
  }

  .manage-companies-link {
    display: flex;
    justify-content: flex-end;
    padding-block-start: var(--padding-xs);
  }

  .manage-companies-link a {
    color: var(--color-blue-dark);
    text-decoration: underline;
  }

  s-tag {
    margin-inline-start: var(--margin-xs);
  }

  hr {
    margin-inline: var(--padding-sm);
  }
}
